/*
 * File: /src/store/modules/webhooks.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import WebhookService from 'src/services/webhookService';

const state = {
  webhooks: undefined
};

const getters = {
  getWebhooks: (state) => state.webhooks,
};
const actions = {
  async fetchWebhooks({ commit, state, rootGetters }) {
    // Only load the data once
    if (state.webhooks == undefined) {
      return WebhookService.fetchAll()
      .then(r => {
        commit('setWebhooks', r.data);
      });
    }
  },
  unloadWebhooks({ commit }) {
    commit('setWebhooks', undefined);
  }
};
const mutations = {
  setWebhooks(state, hooks) {
    state.webhooks = hooks;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
